export default "__VITE_ASSET__9f177c5c__"